// Appels à l'API (adresse relative /api, cookies de session envoyés)
export function errorText(detail: unknown): string {
  if (detail == null) return 'Une erreur est survenue. Réessayez.'
  if (typeof detail === 'string') return detail
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e))).join(' ')
  if (typeof detail === 'object' && 'msg' in detail) return String((detail as { msg: unknown }).msg)
  return String(detail)
}

export class ApiError extends Error {
  status: number
  constructor(status: number, message: string) {
    super(message)
    this.status = status
  }
}

async function send(path: string, method: string, body?: unknown) {
  return fetch(`/api${path}`, {
    method,
    credentials: 'include',
    headers: body !== undefined ? { 'Content-Type': 'application/json' } : undefined,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  })
}

export async function api<T>(path: string, method = 'GET', body?: unknown): Promise<T> {
  let r = await send(path, method, body)
  // Jeton d'accès expiré (15 min) : on le renouvelle une fois avec le cookie refresh_token
  if (r.status === 401 && !path.startsWith('/auth/')) {
    const refreshed = await send('/auth/refresh', 'POST')
    if (refreshed.ok) r = await send(path, method, body)
  }
  const data = await r.json().catch(() => null)
  if (!r.ok) throw new ApiError(r.status, errorText(data?.detail))
  return data as T
}
